import React from 'react'
import { Col, Row } from 'react-bootstrap'
import PosterCdnCheck from '../CreateListmoviespersons/PosterCdnCheck'

function ManualPNTittleImage(props) {
  const { formData, handleInputChange, handleImageUpload, handleSubmit, PnDisable } = props
  return (
    <>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>Title (English):</label>
            <input
              className='form-control'
              type='text'
              name='titleEn'
              value={formData.titleEn}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>

        <Col md={6} xs={12}>
          <div>
            <label>Title (Telugu):</label>
            <input
              className='form-control'
              type='text'
              name='titleTe'
              value={formData.titleTe}
              onChange={handleInputChange}
              required
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>Description (English):</label>
            <textarea
              className='form-control'
              type='text'
              name='descriptionEn'
              value={formData.descriptionEn}
              onChange={handleInputChange}
              rows={5}
              cols={20}
              required
            />
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div>
            <label>Description (Telugu):</label>
            <textarea
              className='form-control'
              type='text'
              name='descriptionTe'
              value={formData.descriptionTe}
              onChange={handleInputChange}
              rows={5}
              cols={20}
              required
            />
          </div>
        </Col>
      </Row>
      <div>
        <label>Poster URL:</label>
        <input
          type='file'
          accept='image/*'
          className='form-control'
          onChange={e => handleImageUpload('posterUrl', e.target.files[0])}
        />
      </div>
      {formData.posterUrl && (
        <img
          src={PosterCdnCheck(formData.posterUrl)}
          className='posterimage'
          alt='PN Poster'
          width='200'
          height='200'
        />
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '20px',
        }}
      >
        <button
          type='button'
          className='btn btn-primary'
          disabled={PnDisable}
          onClick={() => handleSubmit()}
        >
          Send PN
        </button>
      </div>
    </>
  )
}

export default ManualPNTittleImage
